import { pushEcommerceEvent } from '@app/infrastructure/gtm/pushEcommerceEvent';
import { GtmEventName } from '@app/domain/model/gtm/GtmEventName';
import { EcommerceItem } from '@app/domain/model/gtm/EcommerceItem';
import { GtmItemCategory } from '@app/domain/model/gtm/GtmItemCategory';
import { PersonalInsuranceRiskPackage } from '@app/domain/model/eshop/personal-accidents/PersonalInsuranceRiskPackage';
import { TransportOffer } from '@app/domain/model/eshop/transport/TransportOffer';

export interface PersonalAccidentsProposalCalculatedData {
    offers: TransportOffer;
    selectedRisk: Nullable<PersonalInsuranceRiskPackage>;
}

export function trackProposalCalculated(data: PersonalAccidentsProposalCalculatedData): void {
    const totalPrice = data.offers.priceToPayNow ?? 0;
    const firstPolicy = data.offers.policies[0];

    if (!data.selectedRisk) {
        return;
    }

    const price = data.selectedRisk.premiumAfterDiscount ?? data.selectedRisk.premium ?? 0;

    const items: EcommerceItem[] = [
        {
            item_name: data.selectedRisk.name,
            item_id: data.selectedRisk.code,
            price,
            item_category: GtmItemCategory.PersonalAccidentsInsurance,
            quantity: 1,
        },
    ];

    pushEcommerceEvent(GtmEventName.ProposalCalculated, {
        currency: 'EUR',
        value: totalPrice,
        offer_number: firstPolicy?.offerNumber,
        items,
    });
}
